(function () {

  "use strict";

  /* =========================================================
     SAFETY CHECK
     Only run on a page containing the Redtail builder.
     ========================================================= */

  const builderRoot = document.getElementById("rtoBuilder");

  if (!builderRoot) {
    return;
  }


  /* =========================================================
     REDTAIL SKYLOFT VAN BUILDER
     ========================================================= */

  const BASE_PRICE = 595000;

  const sections = [

    /* =======================================================
       01 — EXTERIOR PAINT
       ======================================================= */

    {
      number: "01",
      kicker: "Choose Your Color",
      title: "Exterior Paint",
      description:
        "Choose from 22 Mercedes-Benz exterior paint colors. Every paint color shown is included in the base price.",
      notice:
  "Paint colors shown are digital representations and may vary by screen, lighting conditions and photography. We recommend visiting your local authorized Mercedes-Benz dealer to view paint colors in person before making your final selection. We will make every effort to order your preferred color; however, color availability may occasionally be limited by Mercedes-Benz dealer allocation and vehicle lead times.",
carousel: true,

      options: [

{
  id: "stone-grey",
  group: "exterior-paint",
  type: "single",
  name: "Stone Grey",
  price: 0,
  short: "Included exterior paint color.",
  description: "Mercedes-Benz Stone Grey exterior paint.",
  image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Stone_Grey.jpg?v=1791243133",
  paint: true,
  default: true
},

  {
    id: "pebble-grey",
    group: "exterior-paint",
    type: "single",
    name: "Pebble Grey",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Pebble Grey exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Pebble_Grey.jpg?v=1791243134",
    paint: true
  },

  {
    id: "hightech-silver",
    group: "exterior-paint",
    type: "single",
    name: "Hightech Silver Metallic",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Hightech Silver Metallic exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hightech_Silver.jpg?v=1791243134",
    paint: true
  },

  {
    id: "silver-grey",
    group: "exterior-paint",
    type: "single",
    name: "Silver Grey",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Silver Grey exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Silver_Grey.jpg?v=1791243134",
    paint: true
  },

  {
    id: "selenite-grey",
    group: "exterior-paint",
    type: "single",
    name: "Selenite Grey Metallic",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Selenite Grey Metallic exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Selenite_Grey.jpg?v=1791243134",
    paint: true
  },

  {
    id: "graphite-grey",
    group: "exterior-paint",
    type: "single",
    name: "Graphite Grey",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Graphite Grey exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Graphite_Grey.jpg?v=1791243134",
    paint: true
  },

  {
    id: "blue-grey",
    group: "exterior-paint",
    type: "single",
    name: "Blue Grey",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Blue Grey exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Blue_Grey.jpg?v=1791243133",
    paint: true
  },

  {
    id: "tenorite-grey",
    group: "exterior-paint",
    type: "single",
    name: "Tenorite Grey Metallic",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Tenorite Grey Metallic exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Tenorite_Grey.jpg?v=1791243134",
    paint: true
  },

  {
    id: "cavansite-blue",
    group: "exterior-paint",
    type: "single",
    name: "Cavansite Blue Metallic",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Cavansite Blue Metallic exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Cavansite_Blue.jpg?v=1791243134",
    paint: true
  },

  {
    id: "vanda-blue",
    group: "exterior-paint",
    type: "single",
    name: "Vanda Blue",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Vanda Blue exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Vanda_Blue.jpg?v=1791243134",
    paint: true
  },

  {
    id: "brilliant-blue",
    group: "exterior-paint",
    type: "single",
    name: "Brilliant Blue",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Brilliant Blue exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Brilliant_Blue.jpg?v=1791243134",
    paint: true
  },

  {
    id: "steel-blue",
    group: "exterior-paint",
    type: "single",
    name: "Steel Blue",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Steel Blue exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Steel_Blue.jpg?v=1791243133",
    paint: true
  },

  {
    id: "black-blue",
    group: "exterior-paint",
    type: "single",
    name: "Black Blue",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Black Blue exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Black_Blue.jpg?v=1791243132",
    paint: true
  },

  {
    id: "obsidian-black",
    group: "exterior-paint",
    type: "single",
    name: "Obsidian Black Metallic",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Obsidian Black Metallic exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Obsidian_Black.jpg?v=1791243132",
    paint: true
  },

  {
    id: "jet-black",
    group: "exterior-paint",
    type: "single",
    name: "Jet Black",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Jet Black exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Jet_Black.jpg?v=1791243133",
    paint: true
  },

  {
    id: "velvet-red",
    group: "exterior-paint",
    type: "single",
    name: "Velvet Red",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Velvet Red exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Velvet_Red.jpg?v=1791243133",
    paint: true
  },

  {
    id: "jupiter-red",
    group: "exterior-paint",
    type: "single",
    name: "Jupiter Red",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Jupiter Red exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Jupiter_Red.jpg?v=1791243134",
    paint: true
  },

  {
    id: "sunset-red",
    group: "exterior-paint",
    type: "single",
    name: "Sunset Red",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Sunset Red exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Sunset_Red.jpg?v=1791243134",
    paint: true
  },

  {
    id: "calcite-yellow",
    group: "exterior-paint",
    type: "single",
    name: "Calcite Yellow",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Calcite Yellow exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Calcite_Yellow.jpg?v=1791243134",
    paint: true
  },

  {
    id: "aqua-green",
    group: "exterior-paint",
    type: "single",
    name: "Aqua Green",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Aqua Green exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Aqua_Green.jpg?v=1791243133",
    paint: true
  },

  {
    id: "grey-white",
    group: "exterior-paint",
    type: "single",
    name: "Grey White",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Grey White exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Grey_White.jpg?v=1791243133",
    paint: true
  },

  {
    id: "arctic-white",
    group: "exterior-paint",
    type: "single",
    name: "Arctic White",
    price: 0,
    short: "Included exterior paint color.",
    description: "Mercedes-Benz Arctic White exterior paint.",
    image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Arctic_White.jpg?v=1791243133",
    paint: true
  }

],
    },


    /* =======================================================
       02 — FLOORPLAN
       ======================================================= */

    {
      number: "02",
      kicker: "Choose Your Layout",
      title: "Floorplan",
      description:
        "Start with the layout that best fits how you'll use your Skyloft Van.",

      options: [

        {
          id: "floorplan-2",
          group: "floorplan",
          type: "single",
          name: "2-Seater Floorplan",
          price: 0,
          short:
            "Two front seats with a full-height closet in place of the rear seats.",
          description:
            "The 2-Seater layout replaces the second row of automotive seats with a closet featuring adjustable shelving, hanging space, LED lighting, a 110V outlet and mirror. Includes two Vario F Klima Scheel-Mann front seats.",
          
images: [
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/2-Seater_Layout_3_Large_3bba7988-4a84-47bc-8090-74097688e842.jpg?v=1791246876",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/2-Seater_Layout_2_Large_28e84f65-da73-4261-b7a1-f383f5d90695.jpg?v=1791246875",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/2-Seater_Layout_Large_8911fb57-e339-4aa9-af2f-2a6493904d31.jpg?v=1791246868",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/2-seater_view_2.jpg?v=1791246883",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/2-seater_front_view.jpg?v=1791246882",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/2-seater_view_3.jpg?v=1791246882"
],

          default: true
        },

        {
  id: "floorplan-4",
  group: "floorplan",
  type: "single",
  name: "4-Seater Floorplan",
  price: 5500,
  short:
    "Four automotive seats plus a rear driver's-side window with sliding screen.",
  description:
    "The 4-Seater layout includes two Vario F Klima Scheel-Mann front seats and two Vario F Klima rear seats, plus the rear driver's-side window with sliding screen.",
  images: [
    "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/4-Seater_Layout_2_Large_4a66f968-22a5-4fc7-ae40-115e288e462b.jpg?v=1791246870",
    "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/4-Seater_Layout_3_Large_5b4ed1b5-811e-4d3c-abe5-dd6824bebf62.jpg?v=1791246875",
    "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/4-Seater_Layout_Large_ac70d3a7-1070-489a-b4af-cc9ce813b494.jpg?v=1791246877",
    "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/4-seater_closet_1.jpg?v=1791246876"
  ]
},

        {
          id: "leather-2",
          group: "seat-leather",
          type: "multi",
          name: "Luxe Scheel-Mann Leather — 2-Seater",
          price: 5200,
          short:
            "Luxe leather and custom stitching for the two front Scheel-Mann seats.",
          description:
            "Upgrade the standard black leatherette and cloth-center Scheel-Mann seats to durable, luxe leather and contrasting stitching in the color of your choice. Seats are custom made in Germany.",
          images: [
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Custom_Stitching_2.jpg?v=1791246872"
],

requires: "floorplan-2"

        },

        {
          id: "leather-4",
          group: "seat-leather",
          type: "multi",
          name: "Luxe Scheel-Mann Leather — 4-Seater",
          price: 10400,
          short:
            "Luxe leather and custom stitching for all four Scheel-Mann seats.",
          description:
            "Upgrade the standard black leatherette and cloth-center Scheel-Mann seats to durable, luxe leather and contrasting stitching in the color of your choice on all four automotive seats. Seats are custom made in Germany.",
          images: [
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Custom_Stitching_2.jpg?v=1791246872"
],

requires: "floorplan-4"

        }

      ]
    },


    /* =======================================================
       03 — EXTERIOR & ADVENTURE
       ======================================================= */

    {
      number: "03",
      kicker: "Go Further",
      title: "Exterior & Adventure",
      description:
        "Add equipment for connectivity, storage and backcountry travel.",

      options: [

        {
          id: "starlink",
          type: "multi",
          name: "Starlink Mini Installation",
          price: 1700,
          short:
            "Quick-release mount and hard-wire installation.",
          description:
            "Quick-release mount and hard-wire installation for Starlink Mini. Customer supplies the Starlink Mini hardware and establishes their Starlink account.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Starlink_Quick_Release.jpg?v=1791246856"
          ]
        },

        {
          id: "lp6",
          type: "multi",
          name: "Baja Designs LP6 Light Bar",
          price: 6800,
          short:
            "Six Baja Designs LP6 lights mounted to the front of the Skyloft.",
          description:
            "Six Baja Designs LP6 lights mounted across the front of the Skyloft for substantial auxiliary lighting.",
          
images: [
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Baja_LP6_Lightbar.jpg?v=1791246878",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Baja_LP6_Lightbar_2.jpg?v=1791246850"
]

        },

        {
          id: "rear-winch",
          type: "multi",
          name: "Rear Winch",
          price: 5500,
          short:
            "Warn 12K winch with synthetic line and wireless control.",
          description:
            "Rear-mounted Warn 12K winch with synthetic line, wireless control and Factor55 Flatlink E.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Rear_winch.jpg?v=1791246870"
          ]
        },

        {
          id: "rear-box",
          type: "multi",
          name: "Owl Vans Monster 30 Rear Storage",
          price: 5500,
          short:
            "Exterior rear storage box mounted on B2 Flex carrier rack.",
          description:
            "Owl Vans Monster 30 rear storage box mounted on B2 Flex carrier rack for additional exterior gear storage.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/B2_Flex_Owl_Van_Box.jpg?v=1792167319"
          ]
        },

        {
          id: "exterior-bikes",
          type: "multi",
          name: "Exterior Bike Storage",
          price: 1800,
          short:
            "Two 1Up bike trays mounted vertically on B2 Flex carrier.",
          description:
            "Two 1Up bike trays mounted vertically on B2 Flex carrier.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/1Up_bike_rack_on_B2_Flex.jpg?v=1792167319"
          ]
          
        },

        {
          id: "interior-bikes",
          type: "multi",
          name: "Interior Bike Storage",
          price: 1500,
          short:
            "Two bike mounts inside the rear garage.",
          description:
            "Two interior bike mounts. The garage accommodates up to one large mountain bike and one small or children's bike. Full-size e-bikes generally do not fit unless they are folding models.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Bike_Storage_Interior_for_reference_photo_missing_mounts.jpg?v=1791246881"
          ]
        }

      ]
    },


    /* =======================================================
       04 — INTERIOR
       ======================================================= */

    {
      number: "04",
      kicker: "Comfort & Utility",
      title: "Interior",
      description:
        "Choose additional interior amenities and storage features.",

      options: [

        {
          id: "booth-leather",
          type: "multi",
          name: "Premium Leather Rear Booth",
          price: 4800,
          short:
            "Upgrade the standard UltraLeather rear booth cushions.",
          description:
            "Upgrade the standard vegan UltraLeather rear booth cushions to premium leather.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Rear_Booth_Garrett_Leather.jpg?v=1791246885"
          ]
        },

        {
          id: "biometric",
          type: "multi",
          name: "Hidden Biometric Gear Compartment",
          price: 5200,
          short:
            "Secure hidden storage above the front cab seats.",
          description:
            "A concealed biometric gear compartment above the front cab seats, designed to accommodate customized Pelican foam inserts for camera equipment, drones and other valuable gear.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hidden_Compartment_location.jpg?v=1791246871",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hidden_Compartment_Open.jpg?v=1791246847",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hidden_Compartment_Biometric_Lock.jpg?v=1791246851"
          ]
        },

        {
          id: "dyson",
          type: "multi",
          name: "Dyson Handheld Vacuum",
          price: 1800,
          short:
            "Hard-wired docking station with accessory storage.",
          description:
            "Dyson handheld vacuum with a hard-wired docking station and dedicated storage for vacuum accessories.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Dyson_Under_SInk_Location.jpg?v=1791246882",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Dyson_attachment_storage.jpg?v=1791246884"
          ]
        }

      ]
    },


    /* =======================================================
       05 — COFFEE & BAR
       ======================================================= */

    {
      number: "05",
      kicker: "Cabinet Configuration",
      title: "Coffee & Bar",
      description:
        "Choose how you'd like to configure the upper section of the bar cabinet.",

      options: [

        {
          id: "coffee",
          group: "bar-upper",
          type: "single",
          name: "Nespresso Coffee",
          price: 1400,
          short:
            "Hard-wired Nespresso Mini with integrated pod storage.",
          description:
            "A hard-wired Nespresso Mini coffee maker with dedicated pod storage integrated into the upper bar cabinet.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/coffee_maker_and_nespresso_capsules.jpg?v=1791246881",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Nespresso_Essenza_Mini.jpg?v=1791246839"
          ]
        },

        {
          id: "kettle",
          group: "bar-upper",
          type: "single",
          name: "Aarke Hot Water Kettle",
          price: 1250,
          short:
            "Hard-wired stainless steel Aarke kettle.",
          description:
            "A hard-wired Aarke stainless steel hot water kettle integrated into the upper bar cabinet.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Aarke_kettle_1.jpg?v=1791246879",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/aarke_kettle_3.jpg?v=1791246883",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/aarke_hot_water_kettle.jpg?v=1791246837"
          ]
        },

        {
          id: "bar-empty",
          group: "bar-upper",
          type: "single",
          name: "Storage Shelf",
          price: 0,
          short:
            "Leave the upper cabinet open for general storage.",
          description:
            "No installed appliance. The upper section of the bar cabinet remains available as general storage.",
          image: "",
          default: true
        }

      ]
    },


    /* =======================================================
       06 — KITCHEN & BAR
       ======================================================= */

    {
      number: "06",
      kicker: "Galley & Entertaining",
      title: "Kitchen & Bar",
      description:
        "Add cookware, dedicated dish storage and bar amenities.",

      options: [

        {
          id: "cookware",
          type: "multi",
          name: "10-Piece Induction Cookware",
          price: 850,
          short:
            "Nesting cookware in black or stainless, coordinated with your selected hardware finish.",
          description:
            "A 10-piece nesting induction cookware set. The cookware will be supplied in black or stainless to coordinate with your selected hardware finish.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Nesting_Cookware.jpg?v=1791246876",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Nesting_Cookware_10-piece_2.jpg?v=1791246843",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Nesting_Cookware_10-piece_1.jpg?v=1791246840"
          ]
        },

        {
          id: "dish-storage",
          type: "multi",
          name: "Dish Storage System",
          price: 1800,
          short:
            "Integrated service for four with dedicated storage.",
          description:
            "Dedicated dish storage including dinner plates, salad plates, bowls, cutlery and Yeti 20oz tumblers for four.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Dishware_3.jpg?v=1791246879",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Dishware_2.jpg?v=1791246882",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Dishware_Yeti_20oz_Tumblers.jpg?v=1791246879"
          ]
        },

        {
          id: "knife-storage",
          type: "multi",
          name: "Shun Knife Storage",
          price: 1700,
          short:
            "Integrated knife storage with Shun chef and steak knives.",
          description:
            "Dedicated knife storage with a Shun three-piece chef set and four steak knives. Requires the Dish Storage System.",
          images: [
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Dishware_Silverware_with_Shun_Knives.jpg?v=1791246882",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Shun_Steak_Knives.jpg?v=1791246856",
  "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Shun_Chef_Knives.jpg?v=1791246840"
],
          requires: "dish-storage"
        },

        {
          id: "wine-rack",
          type: "multi",
          name: "Wine Rack",
          price: 1500,
          short:
            "Padded bottle storage, LED lighting and your choice of drinkware.",
          description:
            "Located in the lower section of the bar cabinet. Includes leather-padded racks for up to six bottles of wine or liquor, access from inside or outside the van, LED lighting and your choice of drinkware for four.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/wine_rack_and_coffee_maker_1.jpg?v=1791246882",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/wine_rack_padded.jpg?v=1791246883",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/wine_rack_close_up.jpg?v=1773332052",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/wine_rack_rumblers.jpg?v=1791246878",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/wine_rack_from_outside_3.jpg?v=1791246884"
          ]
        },

        
{
  id: "wine-glasses",
  group: "wine-drinkware",
  type: "single",
  name: "4 Wine Tumblers",
  price: 0,
  short:
    "Four wine tumblers included with the Wine Rack.",
  description:
    "Select four wine tumblers as the included drinkware for your Wine Rack.",
  images: [
    "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/wine_tumbler.jpg?v=1792170282"
  ],
  requires: "wine-rack",
  conditional: "wine-rack"
},


        {
          id: "lowball-glasses",
          group: "wine-drinkware",
          type: "single",
          name: "4 Lowball Tumblers",
          price: 0,
          short:
            "Four lowball tumblers included with the Wine Rack.",
          description:
            "Select four lowball tumblers as the included drinkware for your Wine Rack.",
          images: [
    "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Lowball_Tumbler.jpg?v=1792170282"
  ],
  requires: "wine-rack",
  conditional: "wine-rack"
},

        {
          id: "mixed-glasses",
          group: "wine-drinkware",
          type: "single",
          name: "2 Wine + 2 Lowball Tumblers",
          price: 0,
          short:
            "Two wine tumblers and two lowball tumblers.",
          description:
            "Select two wine tumblers and two lowball tumblers as the included drinkware for your Wine Rack.",
          images: [
    "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/wine_rack_tumblers.jpg?v=1773332052"
  ],
  requires: "wine-rack",
  conditional: "wine-rack"
},

      ]
    },


    /* =======================================================
       07 — FINISHES & DETAILS
       ======================================================= */

    {
      number: "07",
      kicker: "Personalize Your Van",
      title: "Finishes & Details",
      description:
        "Select hardware, speaker finish and other interior details. Additional material selections can be added as Gen 2 specifications are finalized.",

      options: [

        {
          id: "hardware-black",
          group: "hardware",
          type: "single",
          name: "Black Hardware",
          price: 0,
          short:
            "Black push-button knobs, hinges and sink faucet.",
          description:
            "Black finish for the push-button cabinet knobs, hinges and sink faucet.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hardware_Black_1.jpg?v=1791246907",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hardware_Black_2.jpg?v=1791246881",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Black_faucet.jpg?v=1791246880"
          ]
          
        },

        {
          id: "hardware-silver",
          group: "hardware",
          type: "single",
          name: "Silver Hardware",
          price: 0,
          short:
            "Silver push-button knobs, hinges and sink faucet.",
          description:
            "Silver finish for the push-button cabinet knobs, hinges and sink faucet.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hardware_Silver_1.jpg?v=1791246865",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Hardware_Silver_2.jpg?v=1791246850"
          ],
          default: true
        },

        {
          id: "speaker-grey",
          group: "speaker",
          type: "single",
          name: "B&O Speaker — Dark Grey / Silver",
          price: 0,
          short:
            "Included Bang & Olufsen Bluetooth speaker.",
          description:
            "Standard Bang & Olufsen Bluetooth speaker in the Dark Grey / Silver finish.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Bluetooth_speaker_-_grey.jpg?v=1791246879",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Bluetooth_Speaker_Silver_Gray.jpg?v=1791246873"
          ],
          default: true
        },

        {
          id: "speaker-gold",
          group: "speaker",
          type: "single",
          name: "B&O Speaker — Gold Tone",
          price: 0,
          short:
            "Included Bang & Olufsen Bluetooth speaker.",
          description:
            "Standard Bang & Olufsen Bluetooth speaker in the Gold Tone finish.",
          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Bluetooth_Speaker_Gold_Tone.jpg?v=1791246879",
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/gold_speaker_in_place.jpg?v=1792171250"
          ]
        }

      ]
    },


    /* =======================================================
       08 — TOILET SYSTEM
       ======================================================= */

    {
      number: "08",
      kicker: "Bathroom",
      title: "Toilet System",
      description:
        "Choose the toilet system that best matches the way you travel.",

      options: [

        {
          id: "toilet-cassette",
          group: "toilet",
          type: "single",
          name: "Cassette Toilet",
          price: 0,
          short:
            "Traditional flushing RV toilet with a removable 5-gallon waste cassette for convenient emptying.",
description: `The Thetford cassette toilet offers a familiar flushing experience in a compact RV design, most akin to residential style. Waste is collected in an approximately 5-gallon removable cassette rather than a permanently installed black-water tank.


The cassette can be removed and emptied at designated RV dump facilities or other approved waste-disposal locations, making it a practical option for travelers accustomed to conventional RV sanitation systems. The toilet uses a small amount of fresh water for flushing and requires periodic emptying, cleaning, and appropriate tank treatment for odor control.

A great choice for those who prefer a traditional toilet experience with straightforward operation and maintenance.`,
          image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Toilet_Cassette_2.jpg?v=1791246874"
        },

        {
          id: "toilet-ogo",
          group: "toilet",
          type: "single",
          name: "Composting Toilet",
          price: 0,
          
short: "Waterless composting toilet with electric agitation and separate liquid and solid waste containers.",

description: `The OGO Origin is a compact, waterless composting toilet designed for extended off-grid travel. Its liquid-diverting design separates liquid and solid waste, helping manage moisture and minimize odors without requiring a conventional black-water tank or flushing water.

Solid waste is collected in a removable container with a composting medium, such as coconut coir. A 12V electric agitator mixes the contents at the push of a button, eliminating the need for manual cranking. Liquids collect separately in a removable 2.4-gallon container equipped with a level sensor, while an integrated ventilation system helps control moisture and odors.

The system requires periodic emptying of both containers and replenishment of the composting medium. It's a good option for travelers who prioritize water conservation and are comfortable with the maintenance routine of a composting toilet.`,

          image: "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Toilet_OGO_Composting.jpg?v=1791246871"
        },

        {
          id: "toilet-clesana",
          group: "toilet",
          type: "single",
          name: "Dry Flush",
          price: 0,
          
short: "Waterless toilet that automatically heat-seals waste in individual odor-resistant liners for convenient disposal.",

description: `The Clesana C1 R uses an innovative, waterless waste-sealing system that eliminates the need for a black-water tank, flushing water, or composting medium. Instead, a thermo-pressure sealing mechanism automatically encloses waste in individual high-barrier bags after each use.

The sealed bags collect in a removable compartment beneath the toilet and can be disposed of with household trash. This minimizes direct contact with waste and helps contain odors without the need to empty a conventional holding tank. The system operates on 12V power and requires replacement film liners.

The C1 R is especially appealing to travelers who value convenience and a waterless sanitation system without the ongoing handling of liquid or composting waste containers.`,

          images: [ 
            "https://cdn.shopify.com/s/files/1/0254/7023/8766/files/Toilet_Clesana_Dry_Flush.jpg?v=1791246858"
          ],
          default: true
        },

      ]
    }

  ];


  /* =========================================================
     STATE
     ========================================================= */

  const selected = new Set();

  let activeModalOption = null;

  const allOptions = sections.reduce(function (acc, section) {
    return acc.concat(section.options);
  }, []);


  /* =========================================================
     HELPERS
     ========================================================= */

  function money(value) {
    return "$" + Number(value).toLocaleString("en-US");
  }


  function getOption(id) {
    return allOptions.find(function (option) {
      return option.id === id;
    });
  }


  function getSelectedOptions() {
    return allOptions.filter(function (option) {
      return selected.has(option.id);
    });
  }


  function getOptionsTotal() {
    return getSelectedOptions().reduce(function (total, option) {
      return total + option.price;
    }, 0);
  }


  function getGrandTotal() {
    return BASE_PRICE + getOptionsTotal();
  }


  function priceLabel(option) {

    if (option.paint) {
      return "Included";
    }

    if (option.price > 0) {
      return "+" + money(option.price);
    }

    if (option.type === "single") {
      return "Choose One";
    }

    return "Included";
  }


  /* =========================================================
     DEFAULT SELECTIONS
     ========================================================= */

  allOptions.forEach(function (option) {

    if (option.default) {
      selected.add(option.id);
    }

  });


  /* =========================================================
     CREATE OPTION CARD
     ========================================================= */

  function createOptionCard(option) {

    const card =
      document.createElement("div");

    card.className =
      "rto-option-card" +
      (
        option.type === "single"
          ? " is-choice"
          : ""
      ) +
      (
        option.conditional
          ? " is-dependent-choice"
          : ""
      ) +
      (
        option.paint
          ? " is-paint"
          : ""
      ) +
      (
        selected.has(option.id)
          ? " is-selected"
          : ""
      );

    card.dataset.optionId =
      option.id;


    const paintImage =
      option.paint && option.image

        ? '<div class="rto-paint-card-image">' +

            '<img src="' +
              option.image +
              '" alt="' +
              option.name.replace(/"/g, "&quot;") +
              '">' +

          '</div>'

        : "";


    card.innerHTML =
      paintImage +

      '<div class="rto-option-top">' +

        '<h3 class="rto-option-name">' +
          option.name +
        '</h3>' +

        '<div class="rto-option-price">' +
          priceLabel(option) +
        '</div>' +

      '</div>' +

      '<p class="rto-option-short">' +
        option.short +
      '</p>' +

      '<div class="rto-option-footer">' +

        '<button type="button" class="rto-option-details">' +
          (
            option.paint
              ? "View Color"
              : "View Details"
          ) +
        '</button>' +

        '<span class="rto-option-check"></span>' +

      '</div>';


    card.addEventListener(
      "click",
      function (event) {

        if (
          event.target.closest(
            ".rto-option-details"
          )
        ) {

          openOptionModal(option.id);
          return;

        }

        selectOption(option.id);

      }
    );


    return card;

  }


  /* =========================================================
     RENDER BUILDER
     ========================================================= */

  function renderBuilder() {

    const container =
      document.getElementById(
        "rtoBuilderSections"
      );

    if (!container) {
      return;
    }


    container.innerHTML = "";


    sections.forEach(function (section) {

      const sectionEl =
        document.createElement("section");

      sectionEl.className =
        "rto-builder-section";


      sectionEl.innerHTML =

        '<div class="rto-builder-section-header">' +

          '<div class="rto-builder-section-number">' +
            section.number +
          '</div>' +

          '<div class="rto-builder-section-copy">' +

            '<p class="rto-builder-section-kicker">' +
              section.kicker +
            '</p>' +

            '<h2 class="rto-builder-section-title">' +
              section.title +
            '</h2>' +

          '</div>' +

        '</div>' +

        '<p class="rto-builder-section-description">' +
          section.description +
        '</p>' +

        (
          section.notice

            ? '<div class="rto-builder-section-notice">' +
                section.notice +
              '</div>'

            : ''
        );


      /* -----------------------------------------
         PAINT CAROUSEL
         ----------------------------------------- */

      if (section.carousel) {

  const paintViewer =
    document.createElement("div");

  paintViewer.className =
    "rto-paint-viewer";


  const paintOptions =
    section.options;


  let selectedPaintIndex =
    paintOptions.findIndex(function (option) {
      return selected.has(option.id);
    });


  if (selectedPaintIndex < 0) {
    selectedPaintIndex = 0;
  }


  /*
   * The viewed color is independent of the selected color.
   * Start by displaying the customer's currently selected paint.
   */
  let viewedPaintIndex =
    selectedPaintIndex;


  const viewerTop =
    document.createElement("div");

  viewerTop.className =
    "rto-paint-viewer-top";


  const paintPosition =
    document.createElement("div");

  paintPosition.className =
    "rto-paint-viewer-position";


  const arrowGroup =
    document.createElement("div");

  arrowGroup.className =
    "rto-paint-viewer-arrows";


  const previous =
    document.createElement("button");

  previous.type = "button";

  previous.className =
    "rto-paint-viewer-arrow";

  previous.setAttribute(
    "aria-label",
    "Previous paint color"
  );

  previous.innerHTML =
    "&#8592;";


  const next =
    document.createElement("button");

  next.type = "button";

  next.className =
    "rto-paint-viewer-arrow";

  next.setAttribute(
    "aria-label",
    "Next paint color"
  );

  next.innerHTML =
    "&#8594;";


  arrowGroup.appendChild(previous);
  arrowGroup.appendChild(next);

  viewerTop.appendChild(paintPosition);
  viewerTop.appendChild(arrowGroup);


  const imageBox =
    document.createElement("div");

  imageBox.className =
    "rto-paint-viewer-image";


  const image =
    document.createElement("img");

  imageBox.appendChild(image);


  const viewerBottom =
    document.createElement("div");

  viewerBottom.className =
    "rto-paint-viewer-bottom";


  const paintName =
    document.createElement("h3");

  paintName.className =
    "rto-paint-viewer-name";


  const selectButton =
    document.createElement("button");

  selectButton.type = "button";

  selectButton.className =
    "rto-paint-select-button";


  viewerBottom.appendChild(paintName);
  viewerBottom.appendChild(selectButton);


  paintViewer.appendChild(viewerTop);
  paintViewer.appendChild(imageBox);
  paintViewer.appendChild(viewerBottom);

  sectionEl.appendChild(paintViewer);


  function updatePaintViewer() {

    const option =
      paintOptions[viewedPaintIndex];


    if (!option) {
      return;
    }


    
paintPosition.textContent =
  (viewedPaintIndex + 1) +
  " OF " +
  paintOptions.length;



    image.src =
      option.image;

    image.alt =
      option.name +
      " Skyloft Van exterior paint";


    paintName.textContent =
      option.name;


    if (selected.has(option.id)) {

      selectButton.textContent =
        "✓ SELECTED";

      selectButton.classList.add(
        "is-selected"
      );

      selectButton.disabled =
        true;

    } else {

      selectButton.textContent =
        "SELECT THIS COLOR";

      selectButton.classList.remove(
        "is-selected"
      );

      selectButton.disabled =
        false;

    }
    /*
 * Preload the neighboring paint images so arrow
 * navigation feels immediate.
 */
[
  viewedPaintIndex - 1,
  viewedPaintIndex + 1
].forEach(function (index) {

  if (
    index >= 0 &&
    index < paintOptions.length &&
    paintOptions[index].image
  ) {

    const preloadImage =
      new Image();

    preloadImage.src =
      paintOptions[index].image;

  }

});

  }


  previous.addEventListener(
    "click",
    function () {

      viewedPaintIndex =
        (
          viewedPaintIndex -
          1 +
          paintOptions.length
        ) %
        paintOptions.length;

      updatePaintViewer();

    }
  );


  next.addEventListener(
    "click",
    function () {

      viewedPaintIndex =
        (
          viewedPaintIndex +
          1
        ) %
        paintOptions.length;

      updatePaintViewer();

    }
  );


  selectButton.addEventListener(
    "click",
    function () {

      const option =
        paintOptions[viewedPaintIndex];


      if (
        !option ||
        selected.has(option.id)
      ) {
        return;
      }


      /*
       * Remove the previously selected paint without
       * rebuilding the entire configurator.
       */
      paintOptions.forEach(
        function (paintOption) {

          selected.delete(
            paintOption.id
          );

        }
      );


      selected.add(option.id);


      /*
       * Update only this paint viewer and the
       * configuration summary. This is what prevents
       * the viewer from jumping back to the beginning.
       */
      updatePaintViewer();
      renderSummary();

    }
  );


  updatePaintViewer();

}


      /* -----------------------------------------
         NORMAL OPTION GRID
         ----------------------------------------- */

      else {

        const grid =
          document.createElement("div");

        grid.className =
          "rto-option-grid";


        section.options.forEach(
          function (option) {

            if (
              option.conditional &&
              !selected.has(option.conditional)
            ) {
              return;
            }

            
grid.appendChild(
  createOptionCard(option)
);


          }
        );


        sectionEl.appendChild(grid);

      }


      container.appendChild(sectionEl);

    });


    renderSummary();

  }


  /* =========================================================
     SELECT / DESELECT
     ========================================================= */

  function selectOption(id) {

    const option =
      getOption(id);

    if (!option) {
      return;
    }


    /* -----------------------------------------
       DESELECT EXISTING MULTI OPTION
       ----------------------------------------- */

    if (selected.has(id)) {

      if (option.type === "single") {
        return;
      }

      selected.delete(id);

      removeDependents(id);

      renderBuilder();

      return;

    }


    /* -----------------------------------------
       CHECK REQUIREMENT
       ----------------------------------------- */

    if (
      option.requires &&
      !selected.has(option.requires)
    ) {

      showDependency(option);
      return;

    }


    /* -----------------------------------------
       SINGLE-CHOICE GROUP
       ----------------------------------------- */

    if (
      option.type === "single" &&
      option.group
    ) {

      allOptions.forEach(
        function (other) {

          if (
            other.id !== option.id &&
            other.group === option.group
          ) {

            selected.delete(other.id);

            removeDependents(other.id);

          }

        }
      );

    }


    selected.add(id);

    renderBuilder();

  }


  /* =========================================================
     REMOVE DEPENDENT OPTIONS
     ========================================================= */

  function removeDependents(id) {

    allOptions.forEach(
      function (option) {

        if (
          option.requires === id &&
          selected.has(option.id)
        ) {

          selected.delete(option.id);

          removeDependents(option.id);

        }

      }
    );

  }


  /* =========================================================
     DEPENDENCY MESSAGE
     ========================================================= */

  function showDependency(option) {

    const required =
      getOption(option.requires);

    if (!required) {
      return;
    }


    const title =
      document.getElementById(
        "rtoMessageTitle"
      );

    const text =
      document.getElementById(
        "rtoMessageText"
      );

    const actions =
      document.getElementById(
        "rtoMessageActions"
      );


    if (
      !title ||
      !text ||
      !actions
    ) {
      return;
    }


    title.textContent =
      "This option requires " +
      required.name;


    text.textContent =
      option.name +
      " is only available with " +
      required.name +
      ". Please select that configuration first.";


    actions.innerHTML = "";


    const close =
      document.createElement("button");

    close.type = "button";

    close.className =
      "rto-builder-button";

    close.textContent =
      "Got It";


    close.addEventListener(
      "click",
      closeAllModals
    );


    actions.appendChild(close);


    openModal(
      "rtoMessageModal"
    );

  }


  /* =========================================================
     SUMMARY
     ========================================================= */

  function renderSummary() {

    const summary =
      document.getElementById(
        "rtoSummaryOptions"
      );

    if (!summary) {
      return;
    }


    const selectedOptions =
      getSelectedOptions();


    summary.innerHTML = "";


    if (!selectedOptions.length) {

      summary.innerHTML =
        '<div class="rto-summary-empty">' +
          'No options selected yet.' +
        '</div>';

    } else {

      selectedOptions.forEach(
        function (option) {

          const row =
            document.createElement("div");

          row.className =
            "rto-summary-option";


          row.innerHTML =

            '<span class="rto-summary-label">' +
              option.name +
            '</span>' +

            '<span class="rto-summary-value">' +

              (
                option.price === 0

                  ? "Included"

                  : "+" +
                    money(option.price)
              ) +

            '</span>';


          summary.appendChild(row);

        }
      );

    }


    const optionsTotal =
      document.getElementById(
        "rtoOptionsTotal"
      );

    const grandTotal =
      document.getElementById(
        "rtoGrandTotal"
      );

    const mobilePrice =
      document.getElementById(
        "rtoMobilePrice"
      );


    if (optionsTotal) {

      optionsTotal.textContent =
        money(
          getOptionsTotal()
        );

    }


    if (grandTotal) {

      grandTotal.textContent =
        money(
          getGrandTotal()
        );

    }


    if (mobilePrice) {

      mobilePrice.textContent =
        money(
          getGrandTotal()
        );

    }

    // Keep the mobile footer in sync with the desktop pricing summary.
    const mobileOptionsTotal = document.getElementById("rtoMobileOptionsTotal");
    const mobileGrandTotal = document.getElementById("rtoMobileGrandTotal");
    if (mobileOptionsTotal) mobileOptionsTotal.textContent = money(getOptionsTotal());
    if (mobileGrandTotal) mobileGrandTotal.textContent = money(getGrandTotal());

  }


  /* =========================================================
     OPTION DETAILS MODAL
     ========================================================= */

  function openOptionModal(id) {

    const option =
      getOption(id);

    if (!option) {
      return;
    }


    activeModalOption =
      option.id;


    const title =
      document.getElementById(
        "rtoModalTitle"
      );

    const price =
      document.getElementById(
        "rtoModalPrice"
      );

    const description =
      document.getElementById(
        "rtoModalDescription"
      );

    const imageBox =
      document.getElementById(
        "rtoModalImage"
      );

    const button =
      document.getElementById(
        "rtoModalSelect"
      );


    if (
      !title ||
      !price ||
      !description ||
      !imageBox ||
      !button
    ) {
      return;
    }


    title.textContent =
      option.name;


    price.textContent =
      option.paint
        ? "Included"
        : priceLabel(option);


    description.innerHTML =
      "<p>" +
      option.description +
      "</p>";


    const images = option.images || (option.image ? [option.image] : []);

imageBox.innerHTML = "";

if (images.length > 0) {
  let currentIndex = 0;

  const photo = document.createElement("img");
  photo.alt = option.name;
  photo.src = images[0];

  imageBox.appendChild(photo);

  if (images.length > 1) {
    const previous = document.createElement("button");
    const next = document.createElement("button");
    const counter = document.createElement("div");

    previous.type = "button";
    next.type = "button";

    previous.className = "rto-gallery-prev";
    next.className = "rto-gallery-next";
    counter.className = "rto-gallery-counter";

    previous.innerHTML = "&#10094;";
    next.innerHTML = "&#10095;";

    previous.setAttribute("aria-label", "Previous photo");
    next.setAttribute("aria-label", "Next photo");

    function updatePhoto() {
      photo.src = images[currentIndex];
      photo.alt = option.name + " — photo " + (currentIndex + 1);
      counter.textContent = (currentIndex + 1) + " / " + images.length;
    }

    previous.addEventListener("click", function () {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      updatePhoto();
    });

    next.addEventListener("click", function () {
      currentIndex = (currentIndex + 1) % images.length;
      updatePhoto();
    });

    imageBox.appendChild(previous);
    imageBox.appendChild(next);
    imageBox.appendChild(counter);

    updatePhoto();

    images.slice(1).forEach(function (url) {
      const preload = new Image();
      preload.src = url;
    });
  }

} else {
  imageBox.textContent = "Image Coming Soon";
}

    button.textContent =

      selected.has(option.id)

        ? (
            option.type === "single"
              ? "Selected"
              : "Remove From Build"
          )

        : (
            option.paint
              ? "Select This Color"
              : "Add To Build"
          );


    openModal(
      "rtoOptionModal"
    );

  }


  /* =========================================================
     OPTION MODAL SELECT BUTTON
     ========================================================= */

  const modalSelectButton =
    document.getElementById(
      "rtoModalSelect"
    );


  if (modalSelectButton) {

    modalSelectButton.addEventListener(
      "click",
      function () {

        if (!activeModalOption) {
          return;
        }


        const option =
          getOption(
            activeModalOption
          );

        if (!option) {
          return;
        }


        if (
          selected.has(option.id) &&
          option.type === "single"
        ) {

          closeAllModals();
          return;

        }


        closeAllModals();

        selectOption(
          option.id
        );

      }
    );

  }


  /* =========================================================
     BUILD OUTPUT
     ========================================================= */

  function openBuildOutput() {

    const rows =
      document.getElementById(
        "rtoBuildOutputRows"
      );

    const total =
      document.getElementById(
        "rtoBuildOutputTotal"
      );


    if (
      !rows ||
      !total
    ) {
      return;
    }


    rows.innerHTML =

      '<div class="rto-output-row">' +

        '<span>Base Skyloft Van</span>' +

        '<strong>' +
          money(BASE_PRICE) +
        '</strong>' +

      '</div>';


    getSelectedOptions().forEach(
      function (option) {

        rows.innerHTML +=

          '<div class="rto-output-row">' +

            '<span>' +
              option.name +
            '</span>' +

            '<strong>' +

              (
                option.price === 0

                  ? "Included"

                  : "+" +
                    money(option.price)
              ) +

            '</strong>' +

          '</div>';

      }
    );


    total.textContent =
      money(
        getGrandTotal()
      );


    openModal(
      "rtoBuildModal"
    );

  }


  /* =========================================================
     BUILD SUBMISSION — CLOUDFLARE + RESEND + TURNSTILE
     ========================================================= */

  const RTO_SUBMISSION_ENDPOINT =
    "https://redtail-builder-submissions.annie-baa.workers.dev/";
  const RTO_TURNSTILE_SITE_KEY = "0x4AAAAAAFY4UOysunaOuAz5";
  let rtoTurnstileWidgetId = null;
  let rtoTurnstileLoading = false;
  let rtoSubmitting = false;
  let rtoSubmissionId = null;

  function rtoSubmitError(message) {
    const error = document.getElementById("rtoSubmitError");
    if (error) {
      error.textContent = message || "";
      error.hidden = !message;
    }
  }

  function rtoLoadTurnstile() {
    if (window.turnstile) {
      rtoRenderTurnstile();
      return;
    }
    if (rtoTurnstileLoading) return;
    rtoTurnstileLoading = true;
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = function () {
      rtoTurnstileLoading = false;
      rtoRenderTurnstile();
    };
    script.onerror = function () {
      rtoTurnstileLoading = false;
      rtoSubmitError("Security verification could not load. Please refresh and try again.");
    };
    document.head.appendChild(script);
  }

  function rtoRenderTurnstile() {
    const container = document.getElementById("rtoTurnstile");
    if (!container || !window.turnstile || rtoTurnstileWidgetId !== null) return;
    rtoTurnstileWidgetId = window.turnstile.render(container, {
      sitekey: RTO_TURNSTILE_SITE_KEY,
      theme: "light",
      "expired-callback": function () { rtoSubmitError("Verification expired. Please try again."); },
      "error-callback": function () { rtoSubmitError("Security verification failed. Please try again."); }
    });
  }

  /* The Save and Inquiry experiences share the same secure form. */
  let rtoFormMode = "save";

  function setupSubmissionChoices() {
    const modal = document.getElementById("rtoSubmitModal");
    const form = document.getElementById("rtoContactForm");
    if (!modal || !form) return;

    // Add the privacy reassurance directly beneath the email field.
    const email = document.getElementById("rtoContactEmail");
    if (email && !document.getElementById("rtoEmailPrivacy")) {
      const privacy = document.createElement("p");
      privacy.id = "rtoEmailPrivacy";
      privacy.className = "rto-email-privacy";
      privacy.textContent = "We never sell your information or share it with third-party marketers. We won't crowd your inbox.";
      const field = email.closest(".rto-submit-field") || email.parentNode;
      field.appendChild(privacy);
    }

    // Hide the redundant small heading, retaining the primary form title.
    const eyebrow = modal.querySelector(".rto-submit-form .rto-builder-eyebrow");
    if (eyebrow) eyebrow.style.display = "none";

    // Remove the optional comments field from both submission flows.
    const comments = document.getElementById("rtoContactNotes");
    if (comments) {
      const commentsField = comments.closest(".rto-submit-field, .rto-form-field, .rto-field") || comments.parentNode;
      if (commentsField) commentsField.remove();
    }

    // Add referral source after phone, before comments / security verification.
    if (!document.getElementById("rtoReferralSource")) {
      const phone = document.getElementById("rtoContactPhone");
      const phoneField = phone && (phone.closest(".rto-submit-field") || phone.parentNode);
      if (phoneField) {
        const wrapper = document.createElement("div");
        wrapper.className = "rto-submit-field rto-referral-field";
        const label = document.createElement("label");
        label.htmlFor = "rtoReferralSource";
        label.textContent = "How did you hear about Redtail Overland? *";
        label.className = "rto-referral-accessible-label";
        const select = document.createElement("select");
        select.id = "rtoReferralSource";
        select.name = "referralSource";
        select.required = true;
        const options = ["", "Online Search", "Instagram", "Facebook", "YouTube", "Online Article", "Online Forum", "Word of Mouth", "Industry Event", "Saw a Redtail Van", "Other"];
        options.forEach(function (value) {
          const item = document.createElement("option");
          item.value = value;
          item.textContent = value || "How did you hear about Redtail Overland? *";
          if (!value) { item.selected = true; item.disabled = true; }
          select.appendChild(item);
        });
        select.value = "";
        wrapper.appendChild(label);
        wrapper.appendChild(select);
        const detailWrapper = document.createElement("div");
        detailWrapper.className = "rto-submit-field rto-referral-detail";
        detailWrapper.hidden = true;
        const detailLabel = document.createElement("label");
        detailLabel.htmlFor = "rtoReferralDetail";
        const detail = document.createElement("input");
        detail.id = "rtoReferralDetail";
        detail.name = "referralDetail";
        detail.type = "text";
        detail.maxLength = 160;
        detailWrapper.appendChild(detailLabel);
        detailWrapper.appendChild(detail);
        function updateDetail() {
          const event = select.value === "Industry Event";
          const other = select.value === "Other";
          detailWrapper.hidden = !(event || other);
          detail.required = event || other;
          detailLabel.textContent = event ? "Which event? *" : "Please specify *";
          detail.placeholder = event ? "Event name" : "Tell us more";
          if (!event && !other) detail.value = "";
        }
        select.addEventListener("change", updateDetail);
        phoneField.insertAdjacentElement("afterend", wrapper);
        wrapper.insertAdjacentElement("afterend", detailWrapper);
      }
    }

    // Sales qualification questions appear only for Submit to Redtail.
    if (!document.getElementById("rtoInquiryQuestions")) {
      const questions = document.createElement("div");
      questions.id = "rtoInquiryQuestions";
      questions.className = "rto-inquiry-questions";
      questions.hidden = true;

      const definitions = [
        {
          id: "rtoOwnsRig",
          question: "Do you currently own an overland vehicle or rig?",
          options: ["Yes", "No"]
        },
        {
          id: "rtoPurchaseTimeline",
          question: "What is your anticipated purchase timeline?",
          help: "We typically have a 12–18 month lead time for delivery.",
          options: ["Ready to order now", "Within 6 months", "6–12 months", "12+ months", "Just exploring"]
        }
      ];
      definitions.forEach(function (definition) {
        const field = document.createElement("div");
        field.className = "rto-submit-field rto-inquiry-field";
        const label = document.createElement("label");
        label.htmlFor = definition.id;
        label.textContent = definition.question + " *";
        const select = document.createElement("select");
        select.id = definition.id;
        select.name = definition.id;
        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = "Please select one";
        placeholder.disabled = true;
        placeholder.selected = true;
        select.appendChild(placeholder);
        definition.options.forEach(function (value) {
          const option = document.createElement("option");
          option.value = value;
          option.textContent = value;
          select.appendChild(option);
        });
        field.appendChild(label);
        if (definition.help) {
          const help = document.createElement("p");
          help.className = "rto-inquiry-help";
          help.textContent = definition.help;
          field.appendChild(help);
        }
        field.appendChild(select);
        questions.appendChild(field);
      });
      // Multi-select features: show every option without preselecting an answer.
      const featureField = document.createElement("fieldset");
      featureField.id = "rtoImportantFeatureGroup";
      featureField.className = "rto-submit-field rto-inquiry-field rto-feature-checklist";
      const featureLegend = document.createElement("legend");
      featureLegend.textContent = "Which features of the Skyloft Van appeal to you? *";
      featureField.appendChild(featureLegend);
      const featureHelp = document.createElement("p");
      featureHelp.className = "rto-inquiry-help";
      featureHelp.textContent = "Select all that apply.";
      featureField.appendChild(featureHelp);
      ["Skyloft Rooftop Camper", "Offroad Capability", "Offgrid Capability",
       "True Four Season Capability", "Craftsmanship", "Seating and Sleeping for 4",
       "All of the Above", "Other"].forEach(function (feature) {
        const optionLabel = document.createElement("label");
        optionLabel.className = "rto-feature-choice";
        const box = document.createElement("input");
        box.type = "checkbox";
        box.name = "rtoImportantFeatures";
        box.value = feature;
        optionLabel.appendChild(box);
        optionLabel.appendChild(document.createTextNode(feature));
        featureField.appendChild(optionLabel);
      });
      questions.appendChild(featureField);
      const otherField = document.createElement("div");
      otherField.id = "rtoFeatureOtherField";
      otherField.className = "rto-submit-field rto-inquiry-field";
      otherField.hidden = true;
      const otherLabel = document.createElement("label");
      otherLabel.htmlFor = "rtoFeatureOther";
      otherLabel.textContent = "What interests you most? *";
      const otherInput = document.createElement("input");
      otherInput.type = "text";
      otherInput.id = "rtoFeatureOther";
      otherInput.maxLength = 240;
      otherInput.placeholder = "Tell us briefly";
      otherField.appendChild(otherLabel);
      otherField.appendChild(otherInput);
      questions.appendChild(otherField);
      const featureBoxes = Array.from(featureField.querySelectorAll('input[type="checkbox"]'));
      featureBoxes.forEach(function (box) {
        box.addEventListener("change", function () {
          // All of the Above is an alternative to individually checking boxes.
          if (box.checked && box.value === "All of the Above") {
            featureBoxes.forEach(function (other) {
              if (other !== box) other.checked = false;
            });
          } else if (box.checked) {
            const all = featureBoxes.find(function (item) { return item.value === "All of the Above"; });
            if (all) all.checked = false;
          }
          const show = featureBoxes.some(function (item) { return item.value === "Other" && item.checked; });
          otherField.hidden = !show;
          otherInput.required = show && rtoFormMode === "inquiry";
          if (!show) otherInput.value = "";
        });
      });
      const referralDetail = document.querySelector("#rtoReferralDetail");
      const anchor = referralDetail && referralDetail.closest(".rto-referral-detail") ||
        document.getElementById("rtoReferralSource")?.closest(".rto-referral-field");
      if (anchor) anchor.insertAdjacentElement("afterend", questions);
      else form.querySelector('button[type="submit"]')?.parentNode.insertAdjacentElement("beforebegin", questions);
    }

    // A single submit button makes the intention unambiguous.
    const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
    buttons.slice(1).forEach(function (button) { button.remove(); });
    if (buttons[0]) buttons[0].id = "rtoSubmitButton";
  }

  function openSubmitForm(mode) {
    rtoFormMode = mode === "inquiry" ? "inquiry" : "save";
    const modal = document.getElementById("rtoSubmitModal");
    const form = document.getElementById("rtoContactForm");
    if (modal && form) {
      const heading = modal.querySelector(".rto-submit-form h2");
      const eyebrow = modal.querySelector(".rto-submit-form .rto-builder-eyebrow");
      const intro = modal.querySelector(".rto-submit-form > p:not(.rto-builder-eyebrow)");
      const note = form.querySelector(".rto-submit-note");
      const submit = form.querySelector('button[type="submit"]');
      if (eyebrow) eyebrow.textContent = rtoFormMode === "save" ? "SAVE YOUR CONFIGURATION" : "CONTACT REDTAIL OVERLAND";
      if (heading) heading.textContent = rtoFormMode === "save" ? "Save My Build" : "Submit to Redtail";
      if (intro) intro.textContent = rtoFormMode === "save"
        ? "We'll email you a copy of your configuration and estimated pricing. This does not request a sales follow-up."
        : "Send your configuration and estimated pricing to Redtail. A team member will follow up with you.";
      if (note) note.textContent = rtoFormMode === "save"
        ? "We'll email you a copy of your configuration for your records. No sales follow-up is requested."
        : "Send your configuration to our team, and a Redtail representative will follow up with you. No purchase commitment required.";
      if (submit) {
        submit.textContent = rtoFormMode === "save" ? "SAVE MY BUILD" : "SUBMIT TO REDTAIL";
        submit.value = rtoFormMode;
      }
      const questions = document.getElementById("rtoInquiryQuestions");
      if (questions) {
        const inquiry = rtoFormMode === "inquiry";
        questions.hidden = !inquiry;
        questions.querySelectorAll("select").forEach(function (select) {
          select.required = inquiry;
          if (inquiry) {
            select.selectedIndex = 0;
            select.value = "";
          }
        });
        const otherInput = document.getElementById("rtoFeatureOther");
        const featureBoxes = questions.querySelectorAll('input[name="rtoImportantFeatures"]');
        featureBoxes.forEach(function (box) { box.checked = false; });
        const otherField = document.getElementById("rtoFeatureOtherField");
        if (otherField) otherField.hidden = true;
        if (otherInput) { otherInput.value = ""; otherInput.required = false; }
      }
      // Remove the legacy explanatory line beneath the button, if present.
      const legacyFooter = modal.querySelector("#rtoSubmissionFooterCopy") ||
        Array.from(modal.querySelectorAll("p, small, span, div")).find(function (element) {
          return element.children.length === 0 &&
            /[“"]?(?:Email My Build|Save My Build|Submit to Redtail)[”"]?\s*(?:emails|is for|sends)/i.test(element.textContent || "");
        });
      if (legacyFooter) legacyFooter.remove();
    }
    rtoSubmitError("");
    openModal("rtoSubmitModal");
    rtoLoadTurnstile();
  }

  setupSubmissionChoices();
  // Match the builder's desktop action label to the submission form.
  const rtoDesktopSaveButton = document.getElementById("rtoGetBuild");
  if (rtoDesktopSaveButton) rtoDesktopSaveButton.textContent = "SAVE MY BUILD";

  const rtoContactForm = document.getElementById("rtoContactForm");
  if (rtoContactForm) {
    rtoContactForm.addEventListener("submit", async function (event) {
      event.preventDefault();
      if (rtoSubmitting) return;

      // A Shopify preview URL is not an approved Turnstile hostname.
      // For reliable testing, use the actual storefront hostname.
      if (!["redtailoverland.com", "www.redtailoverland.com"].includes(window.location.hostname)) {
        rtoSubmitError("Submissions must be tested on the regular redtailoverland.com website, not the Shopify preview URL. Your configuration is still here.");
        return;
      }

      const modeButton = event.submitter;
      const mode = rtoFormMode;
      const name = document.getElementById("rtoContactName").value.trim();
      const email = document.getElementById("rtoContactEmail").value.trim();
      const phone = document.getElementById("rtoContactPhone").value.trim();
      const website = document.getElementById("rtoContactWebsite").value;
      const ownsRig = mode === "inquiry" ? (document.getElementById("rtoOwnsRig")?.value || "") : "";
      const purchaseTimeline = mode === "inquiry" ? (document.getElementById("rtoPurchaseTimeline")?.value || "") : "";
      const importantFeatures = mode === "inquiry"
        ? Array.from(document.querySelectorAll('#rtoImportantFeatureGroup input[name="rtoImportantFeatures"]:checked'))
            .map(function (box) { return box.value; }) : [];
      const featureOther = mode === "inquiry" && importantFeatures.includes("Other")
        ? (document.getElementById("rtoFeatureOther")?.value.trim() || "") : "";
      const selectedPaint = getSelectedOptions().find(function (option) { return option.paint; });
      const paintId = selectedPaint ? selectedPaint.id : "";
      const referralSource = document.getElementById("rtoReferralSource")?.value || "";
      const referralDetail = document.getElementById("rtoReferralDetail")?.value.trim() || "";
      if (!referralSource || (["Industry Event", "Other"].includes(referralSource) && !referralDetail)) {
        rtoSubmitError("Please tell us how you heard about Redtail Overland.");
        return;
      }
      if (mode === "inquiry" && (!ownsRig || !purchaseTimeline || !importantFeatures.length ||
          (importantFeatures.includes("Other") && !featureOther))) {
        rtoSubmitError("Please answer the inquiry questions and select at least one feature.");
        return;
      }
      if (!window.turnstile || rtoTurnstileWidgetId === null) {
        rtoSubmitError("Security verification is still loading. Please wait and try again.");
        return;
      }
      const turnstileToken = window.turnstile.getResponse(rtoTurnstileWidgetId);
      if (!turnstileToken) {
        rtoSubmitError("Please wait for security verification, then try again.");
        return;
      }

      const lines = [
        "SKYLOFT VAN CONFIGURATION",
        "Date: " + new Date().toLocaleString("en-US", { dateStyle: "long", timeStyle: "short" }),
        "Base Skyloft Van: " + money(BASE_PRICE), "", "SELECTED CONFIGURATION:"
      ];
      getSelectedOptions().forEach(function (option) {
        lines.push("- " + option.name + " — " + (option.price ? "+" + money(option.price) : "Included"));
      });
      lines.push("", "OPTIONS TOTAL: " + money(getOptionsTotal()));
      lines.push("ESTIMATED BUILD TOTAL: " + money(getGrandTotal()));

      if (!rtoSubmissionId) {
        rtoSubmissionId = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : "";
      }
      const payload = {
        mode, name, email, phone, website, paintId, referralSource, referralDetail,
        ownsRig, purchaseTimeline, importantFeatures, featureOther,
        configuration: lines.join("\n"),
        turnstileToken,
        submissionId: rtoSubmissionId
      };
      const buttons = Array.from(rtoContactForm.querySelectorAll('button[type="submit"]'));
      rtoSubmitting = true;
      rtoSubmitError("");
      buttons.forEach(function (button) { button.disabled = true; });
      const originalLabel = modeButton ? modeButton.textContent : "";
      if (modeButton) modeButton.textContent = "Sending...";
      try {
        const response = await fetch(RTO_SUBMISSION_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || !result.success) {
          throw new Error(result.error || "Submission could not be completed.");
        }
        closeAllModals();
        const eyebrow = document.getElementById("rtoMessageEyebrow");
        const title = document.getElementById("rtoMessageTitle");
        const message = document.getElementById("rtoMessageText");
        const actions = document.getElementById("rtoMessageActions");
        if (eyebrow) eyebrow.textContent = "Build Sent";
        if (title) title.textContent = mode === "save" ? "Your Build Has Been Emailed" : "Your Build Has Been Submitted";
        if (message) message.textContent = mode === "save"
          ? "We've emailed your Skyloft Van configuration to you. No sales follow-up was requested."
          : "We've received your Skyloft Van configuration and emailed you a copy. Our team will follow up with you.";
        if (actions) {
          actions.innerHTML = "";
          const done = document.createElement("button");
          done.type = "button";
          done.className = "rto-builder-button";
          done.textContent = "Return to Builder";
          done.addEventListener("click", closeAllModals);
          actions.appendChild(done);
        }
        rtoContactForm.reset();
        const referralDetailField = document.getElementById("rtoReferralDetail");
        if (referralDetailField) { referralDetailField.required = false; referralDetailField.closest(".rto-referral-detail").hidden = true; }
        rtoSubmissionId = null;
        if (window.turnstile && rtoTurnstileWidgetId !== null) window.turnstile.reset(rtoTurnstileWidgetId);
        openModal("rtoMessageModal");
      } catch (error) {
        rtoSubmitError((error && error.message ? error.message : "Unable to confirm submission.") +
          " If you are unsure whether it was received, contact Redtail before retrying to avoid duplicates.");
        if (window.turnstile && rtoTurnstileWidgetId !== null) window.turnstile.reset(rtoTurnstileWidgetId);
      } finally {
        rtoSubmitting = false;
        buttons.forEach(function (button) { button.disabled = false; });
        if (modeButton) modeButton.textContent = originalLabel;
      }
    });
  }

  /* =========================================================
     RESET
     ========================================================= */

  function resetBuild() {

    selected.clear();


    allOptions.forEach(
      function (option) {

        if (option.default) {
          selected.add(option.id);
        }

      }
    );


    renderBuilder();

  }


  /* =========================================================
     MODAL HELPERS
     ========================================================= */

  function openModal(id) {

    closeAllModals();


    const modal =
      document.getElementById(id);


    if (modal) {

      modal.classList.add(
        "is-open"
      );

      document.body.style.overflow =
        "hidden";

    }

  }


  function closeAllModals() {

    document
      .querySelectorAll(
        ".rto-builder-modal"
      )
      .forEach(
        function (modal) {

          modal.classList.remove(
            "is-open"
          );

        }
      );


    document.body.style.overflow =
      "";

  }


  document
    .querySelectorAll(
      "[data-close-modal]"
    )
    .forEach(
      function (button) {

        button.addEventListener(
          "click",
          closeAllModals
        );

      }
    );


  document
    .querySelectorAll(
      ".rto-builder-modal"
    )
    .forEach(
      function (modal) {

        modal.addEventListener(
          "click",
          function (event) {

            if (
              event.target === modal
            ) {

              closeAllModals();

            }

          }
        );

      }
    );


  document.addEventListener(
    "keydown",
    function (event) {

      if (
        event.key === "Escape"
      ) {

        closeAllModals();

      }

    }
  );


  /* =========================================================
     MAIN BUTTONS
     ========================================================= */

  const getBuildButton =
    document.getElementById(
      "rtoGetBuild"
    );

  const mobileViewButton =
    document.getElementById(
      "rtoMobileView"
    );

  const sendBuildButton =
    document.getElementById(
      "rtoSendBuild"
    );

  const outputSendButton =
    document.getElementById(
      "rtoOutputSend"
    );

  const printBuildButton =
    document.getElementById(
      "rtoPrintBuild"
    );

  const resetBuildButton =
    document.getElementById(
      "rtoResetBuild"
    );


  if (getBuildButton) {
    getBuildButton.addEventListener("click", function () { openSubmitForm("save"); });
  }

  if (mobileViewButton) {
    mobileViewButton.addEventListener("click", function () { openSubmitForm("save"); });
  }

  if (sendBuildButton) {
    sendBuildButton.addEventListener("click", function () { openSubmitForm("inquiry"); });
  }

  if (outputSendButton) {
    outputSendButton.addEventListener("click", function () { openSubmitForm("inquiry"); });
  }


  if (printBuildButton) {

    printBuildButton.addEventListener(
      "click",
      function () {

        window.print();

      }
    );

  }


  if (resetBuildButton) {

    resetBuildButton.addEventListener(
      "click",
      resetBuild
    );

  }


    /* Paint disclaimer */
/* =========================================================
   PAINT VIEWER STYLES
   ========================================================= */

const paintStyle =
  document.createElement(
    "style"
  );

paintStyle.textContent = `

  /* Paint disclaimer */
  .rto-builder-section-notice {
    margin: 18px 0 24px;
    padding: 15px 18px;
    border-left: 3px solid #9f1d20;
    background: #f4f2ee;
    color: #4b4b4b;
    font-size: 13px;
    line-height: 1.55;
  }


  /* =======================================================
     SINGLE-IMAGE PAINT VIEWER
     ======================================================= */

  .rto-paint-viewer {
    width: 100%;
    min-width: 0;
  }


  /* Color name/count + arrows */

  .rto-paint-viewer-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 14px;
  }


  .rto-paint-viewer-position {
    color: #777;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .10em;
    line-height: 1.4;
    text-transform: uppercase;
  }


  .rto-paint-viewer-arrows {
    display: flex;
    flex: 0 0 auto;
    gap: 8px;
  }


  .rto-paint-viewer-arrow {
    appearance: none;
    -webkit-appearance: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    padding: 0;
    border: 1px solid #c9c6c0;
    border-radius: 0;
    background: #fff;
    color: #111;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    transition:
      background .18s ease,
      color .18s ease,
      border-color .18s ease;
  }


  .rto-paint-viewer-arrow:hover {
    background: #111;
    border-color: #111;
    color: #fff;
  }


  /* Large vehicle image */

  .rto-paint-viewer-image {
    position: relative;
    width: 100%;
    aspect-ratio: 4 / 3;
    overflow: hidden;
    background: #efede8;
  }


  .rto-paint-viewer-image img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }


  /* Color name + selection button */

  .rto-paint-viewer-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 18px 0 0;
  }


  .rto-paint-viewer-name {
    margin: 0;
    color: #111;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
  }


  .rto-paint-select-button {
    appearance: none;
    -webkit-appearance: none;
    flex: 0 0 auto;
    min-width: 190px;
    padding: 14px 20px;
    border: 1px solid #9f1d20;
    border-radius: 0;
    background: #9f1d20;
    color: #fff;
    font-family: inherit;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .09em;
    line-height: 1.2;
    text-align: center;
    text-transform: uppercase;
    cursor: pointer;
    transition:
      background .18s ease,
      color .18s ease,
      border-color .18s ease;
  }


  .rto-paint-select-button:hover {
    background: #7f1719;
    border-color: #7f1719;
  }


  .rto-paint-select-button.is-selected,
  .rto-paint-select-button.is-selected:hover {
    border-color: #111;
    background: #111;
    color: #fff;
    cursor: default;
  }


  /* Mobile */

  @media (max-width: 700px) {

    .rto-builder-section-notice {
      margin: 14px 0 20px;
      padding: 14px 15px;
      font-size: 12px;
    }


    .rto-paint-viewer-top {
      gap: 12px;
      margin-bottom: 12px;
    }


    .rto-paint-viewer-position {
      font-size: 10px;
    }


    .rto-paint-viewer-arrow {
      width: 38px;
      height: 38px;
    }


    .rto-paint-viewer-bottom {
      align-items: stretch;
      flex-direction: column;
      gap: 14px;
      padding-top: 15px;
    }


    .rto-paint-viewer-name {
      font-size: 18px;
    }


    .rto-paint-select-button {
      width: 100%;
      min-width: 0;
    }

  }

/* Compact feature checkbox layout */
.rto-feature-checklist .rto-feature-choice {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 12px !important;
  margin: 0 !important;
  padding: 7px 0 !important;
  cursor: pointer;
}

.rto-feature-checklist .rto-feature-choice input[type="checkbox"] {
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  display: block !important;
  flex: 0 0 20px !important;
  width: 20px !important;
  height: 20px !important;
  margin: 0 !important;
  accent-color: #87181a;
}

.rto-feature-checklist .rto-feature-choice {
  font-size: 15px !important;
  line-height: 1.4 !important;
  font-weight: 400 !important;
  text-transform: none !important;
}

`;

document.head.appendChild(
  paintStyle
);
  /* =========================================================
      MOBILE TOTAL — STATIC FOOTER (NO FLOATING BAR)
      Reuse the existing bottom mobile button and price calculations.
      ========================================================= */

  (function setupMobilePriceSummary() {
    const bottomButton = builderRoot.querySelector(".rto-mobile-review--bottom");
    if (!bottomButton || document.getElementById("rtoMobilePriceSummary")) return;

    const panel = document.createElement("div");
    panel.id = "rtoMobilePriceSummary";
    panel.className = "rto-mobile-price-summary";
    panel.innerHTML = `
      <div class="rto-mobile-price-kicker">YOUR SKYLOFT VAN</div>
      <div class="rto-mobile-price-row"><span>Base Skyloft Van</span><strong>${money(BASE_PRICE)}</strong></div>
      <div class="rto-mobile-price-row"><span>Selected Options</span><strong id="rtoMobileOptionsTotal">$0</strong></div>
      <div class="rto-mobile-price-divider"></div>
      <div class="rto-mobile-price-total-label">ESTIMATED BUILD PRICE</div>
      <div class="rto-mobile-price-total" id="rtoMobileGrandTotal">${money(BASE_PRICE)}</div>
    `;
    bottomButton.parentNode.insertBefore(panel, bottomButton);
    // Replace the single "Review" CTA with two distinct choices.
    bottomButton.removeAttribute("onclick");
    bottomButton.textContent = "SAVE MY BUILD";
    bottomButton.addEventListener("click", function () { openSubmitForm("save"); });
    const actions = document.createElement("div");
    actions.className = "rto-mobile-price-actions";
    actions.appendChild(bottomButton);
    const inquiryButton = document.createElement("button");
    inquiryButton.type = "button";
    inquiryButton.className = "rto-mobile-review rto-mobile-review--bottom rto-mobile-inquiry";
    inquiryButton.textContent = "SEND TO REDTAIL";
    inquiryButton.addEventListener("click", function () { openSubmitForm("inquiry"); });
    actions.appendChild(inquiryButton);
    panel.appendChild(actions);

    // Retain the early mobile CTA, but make its action explicit.
    const topButton = builderRoot.querySelector(".rto-mobile-review--top");
    if (topButton) topButton.textContent = "SAVE MY BUILD →";

    const style = document.createElement("style");
    style.textContent = `
      .rto-mobile-price-summary { display: none; }
      #rtoSubmitModal .rto-inquiry-questions[hidden],
      #rtoSubmitModal #rtoFeatureOtherField[hidden] { display: none !important; }
      #rtoSubmitModal .rto-inquiry-field { margin: 14px 0; }
      #rtoSubmitModal .rto-feature-checklist {
        border: 0; padding: 0; min-width: 0;
      }
      #rtoSubmitModal .rto-feature-checklist legend {
        display: block; padding: 0; margin-bottom: 8px;
        font-size: inherit; color: inherit;
      }
      #rtoSubmitModal .rto-feature-choice {
        display: flex; align-items: center; gap: 10px; margin: 0;
        padding: 8px 0; font-size: 14px; line-height: 1.4; cursor: pointer;
      }
      #rtoSubmitModal .rto-feature-choice input[type="checkbox"] {
        -webkit-appearance: none !important;
        appearance: none !important;
        flex: 0 0 18px;
        width: 18px !important;
        height: 18px !important;
        min-height: 18px !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 1px solid #999 !important;
        border-radius: 0 !important;
        background: #fff !important;
        position: relative;
        cursor: pointer;
      }
      #rtoSubmitModal .rto-feature-choice input[type="checkbox"]:checked {
        background: #87181a !important;
        border-color: #87181a !important;
      }
      #rtoSubmitModal .rto-feature-choice input[type="checkbox"]:checked::after {
        content: "";
        position: absolute;
        left: 5px;
        top: 2px;
        width: 5px;
        height: 9px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
      #rtoSubmitModal .rto-feature-choice input[type="checkbox"]:focus-visible {
        outline: 2px solid #87181a;
        outline-offset: 3px;
      }
      #rtoSubmitModal .rto-inquiry-field label { display:block; margin-bottom:7px; }
      #rtoSubmitModal .rto-inquiry-help {
        margin: 0 0 9px; font-size:12px; line-height:1.5; color:#666;
      }
      #rtoSubmitModal .rto-inquiry-field select,
      #rtoSubmitModal .rto-inquiry-field input {
        width:100%; min-height:45px; box-sizing:border-box;
        padding:12px; border:1px solid #aaa; border-radius:0;
        background:#fff; color:#191919; font-size:16px;
      }
      #rtoSubmitModal #rtoSubmitButton { width: 100%; }
      #rtoSubmitModal .rto-referral-field select,
      #rtoSubmitModal .rto-referral-detail input {
        display: block; width: 100%; box-sizing: border-box;
        padding: 13px 12px; min-height: 45px;
        border: 1px solid #aaa; border-radius: 0;
        background: #fff; color: #111; font-size: 16px;
      }
      /* Use the question itself as the dropdown prompt. Keep label accessible. */
      #rtoSubmitModal .rto-referral-accessible-label {
        position: absolute !important; width: 1px; height: 1px;
        overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap;
      }
      #rtoSubmitModal .rto-referral-field select {
        -webkit-appearance: none; appearance: none;
        padding-right: 46px;
        background-image:
          linear-gradient(45deg, transparent 50%, #333 50%),
          linear-gradient(135deg, #333 50%, transparent 50%);
        background-position:
          calc(100% - 22px) 50%,
          calc(100% - 16px) 50%;
        background-size: 6px 6px, 6px 6px;
        background-repeat: no-repeat;
        cursor: pointer;
      }
      #rtoSubmitModal .rto-referral-field select:invalid { color: #666; }
      #rtoSubmitModal .rto-referral-detail[hidden] { display: none !important; }
      #rtoSubmitModal .rto-referral-field select:focus,
      #rtoSubmitModal .rto-referral-detail input:focus {
        outline: 2px solid #9f1d20; outline-offset: 1px;
      }
      #rtoSubmitModal .rto-email-privacy {
        margin: 7px 0 0;
        font-size: 11px;
        line-height: 1.45;
        color: #666;
      }
      @media (max-width: 900px) {
        .rto-mobile-price-summary {
          display: block;
          width: 100%;
          margin: 10px 0 30px;
          padding: 24px 22px 19px;
          background: #242424;
          color: #fff;
          box-sizing: border-box;
        }
        .rto-mobile-price-kicker {
          margin-bottom: 18px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: .14em;
          color: #ddd;
        }
        .rto-mobile-price-row {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 16px;
          margin: 0 0 12px;
          font-size: 13px;
          line-height: 1.5;
          color: #ddd;
        }
        .rto-mobile-price-row strong {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          white-space: nowrap;
        }
        .rto-mobile-price-divider {
          height: 1px;
          margin: 19px 0;
          background: rgba(255,255,255,.2);
        }
        .rto-mobile-price-total-label {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: .15em;
          color: #ccc;
        }
        .rto-mobile-price-total {
          margin-top: 5px;
          font-size: clamp(28px, 7vw, 36px);
          font-weight: 600;
          line-height: 1.15;
          color: #fff;
        }
        .rto-mobile-price-actions { display: grid; grid-template-columns: 1fr; gap: 10px; margin-top: 22px; }
        .rto-mobile-price-summary .rto-mobile-review--bottom {
          display: block;
          width: 100%;
          margin: 0;
          background: #9f1d20;
          border-color: #9f1d20;
        }
        .rto-mobile-price-summary .rto-mobile-review--bottom:hover {
          background: #7f1719;
          border-color: #7f1719;
        }
        .rto-mobile-price-summary .rto-mobile-inquiry {
          background: transparent;
          border: 1px solid #ddd;
          color: #fff;
        }
        .rto-mobile-price-summary .rto-mobile-inquiry:hover {
          background: #383838;
          border-color: #fff;
        }
        .rto-mobile-price-summary::after {
          content: 'Pricing and specifications subject to confirmation.';
          display: block;
          margin-top: 12px;
          text-align: center;
          font-size: 10px;
          line-height: 1.5;
          color: #c4c4c4;
        }
      }
    `;
    document.head.appendChild(style);
  })();

  /* =========================================================
     INITIALIZE
     ========================================================= */

  renderBuilder();

})();